<template>
  <div class="teaching-supply-elective">
    <PlatDataGridSite grid-id="PeTchElectiveSupply"
                      :extra-params="extraParams"
                      show-label></PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
export default {
  name: 'TeachingSupplyView',
  components: {
    PlatDataGridSite
  },
  computed: {
    extraParams () {
      return { viewModel: '1' }
    }
  }
}
</script>

<style lang="scss">
.teaching-supply-elective {
  height: 100%;
}
</style>
